import React from "react";
import { useTranslation } from "react-i18next";
import { NavButton } from "../navigation/nav";

const PromoBlock = ({ children, buttonText, inverted, onModalOpen }) => {
  const { t } = useTranslation()

  return (
    <div className='container1300'>

      <div className={`br30 row ${inverted ? ' row-reverse' : ''} space-between mob-column `} style={{ backgroundColor: '#ffffff' }}>
        <div className='column column-start mob-text-center mob-column-center promo-block'>
          {children ? children : (
            <p className='mb36 sato36 font500 mob-font-24'>{t('An all-new platform.')}<br />
              {t('An all-new world for security teams.')}</p>
          )
          }
          {/* {buttonText && <NavButton onClick={onModalOpen} to='/' variant='dark' size='md' >{buttonText}</NavButton>} */}

          <div className="hide mob-show" style={{ height: 30 }}></div>

        </div>
        <div className="get-started-home-orig mob-hide"></div>

      </div>
    </div >
  )
}

export default PromoBlock